import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {I18nService} from '../gui/i18n.service';
import {mergeMap, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ApiEndpoints} from '../../_constants/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class GuidesService {
  private http = inject(HttpClient);
  private i18nService = inject(I18nService);
  private apiEndpoints = inject(ApiEndpoints);


  getGuide(guideName: string): Observable<ArrayBuffer> {
    console.info(`Getting data for guide ${guideName}`);
    return this.i18nService.getTranslation(`guides.${guideName}.pdf`).pipe(
      mergeMap(t => this.http.get(`${this.apiEndpoints.guides}?guideType=${t}`, {responseType: 'arraybuffer'})), tap(() => { console.debug('Data for guide retrieved.'); }));
  }

}
